import React from 'react';
import { Tabs } from '@blueprintjs/core';
import styled from 'styled-components';

/**
 * Drawer main tabs.
 */
export function DrawerMainTabs({ children, ...restProps }: any) {
  return (
    <DrawerMainTabsRoot>
      <Tabs animate={true} large={true} {...restProps}>
        {children}
      </Tabs>
    </DrawerMainTabsRoot>
  );
}

const DrawerMainTabsRoot = styled.div`
  /*
   * Onglets « façon Balance » : barre claire, libellés discrets, indicateur fin
   * couleur accent. No heavy backgrounds — the tabs sit flush on the drawer's
   * light body.
   */
  .bp4-tabs {
    --x-tab-list-background: var(--color-card-background, #fff);
    --x-tab-list-border: var(--color-card-border, #e5e9f0);
    --x-tab-item-text: var(--color-muted-text, #94a3b8);
    --x-tab-item-height: 40px;

    .bp4-tab-list {
      position: relative;
      background-color: var(--x-tab-list-background);
      padding: 0 16px;
      border-bottom: 1px solid var(--x-tab-list-border);

      > *:not(:last-child) {
        margin-right: 4px;
      }
      .bp4-tab {
        color: var(--x-tab-item-text);
        line-height: var(--x-tab-item-height);
        font-weight: 500;
      }
      &.bp4-large > .bp4-tab {
        font-size: 13px;
        margin: 0 0.75rem;

        &[aria-selected='true'],
        &:not([aria-disabled='true']):hover {
          color: var(--color-accent, #4f46e5);
        }
      }
      .bp4-tab-indicator-wrapper .bp4-tab-indicator {
        height: 2px;
        bottom: 0;
        background-color: var(--color-accent, #4f46e5);
      }
    }

    .bp4-tab-panel {
      margin-top: 0;

      .card {
        margin: 14px;
      }
    }

    .bp4-dark & {
      --x-tab-list-background: var(--color-dark-gray2, #2f343c);
      --x-tab-list-border: var(--color-dark-gray4, #383e47);
      --x-tab-item-text: var(--color-light-gray1);
    }
  }
`;
